import {
    CATEGORY_CREATE,
    CATEGORY_LIST,
    CATEGORY_UPDATE
} from "../actions";

export function category(currentState = {}, action) {
    switch (action.type) {
        case CATEGORY_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case CATEGORY_LIST:
            return currentState = action
        case CATEGORY_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}